import React from 'react';
import Main from '../Main';
import styles from './NewPropertyPage.scss';
import NewPropertyWizard from './NewPropertyWizard';

export interface INewPropertyPageProps { }

const NewPropertyPage: React.FC<React.PropsWithChildren<INewPropertyPageProps>> = () => {
    return (
        <Main className={styles.newPropertyPage}>
            <NewPropertyWizard />
        </Main>
    );
};

export default NewPropertyPage;
